import { render } from "./MobileInviteHeader.vue?vue&type=template&id=479b0e22&scoped=true"
import script from "./MobileInviteHeader.vue?vue&type=script&lang=js"
export * from "./MobileInviteHeader.vue?vue&type=script&lang=js"

import "./MobileInviteHeader.vue?vue&type=style&index=0&id=479b0e22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479b0e22"],['__file',"src/views/mobile/layout/components/MobileInviteHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "479b0e22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('479b0e22', __exports__)) {
    api.reload('479b0e22', __exports__)
  }
  
  module.hot.accept("./MobileInviteHeader.vue?vue&type=template&id=479b0e22&scoped=true", () => {
    api.rerender('479b0e22', render)
  })

}


export default __exports__